import React, { useState, useContext } from "react"
import type { MenuProps } from 'antd'
import { Row, Menu, Dropdown } from 'antd'
import { Icon } from "../../common/Icon"
import classes from "./Header.module.css"

import i18next from "i18next"
import LanguageContext from "./../../store/language-context"
import { useTranslation } from "react-i18next"
import { CaretUpOutlined, MenuOutlined } from '@ant-design/icons';

import Menu1 from "pages/MainMenu/Menu"
import logo from "../../img/logo.png"

import {
  HeaderSection,
  LogoContainer,
} from "./styles"
import { Link } from "react-router-dom"

const Header = () => {
  const languageCtx = useContext(LanguageContext);
  const { i18n } = useTranslation();
  const { t } = useTranslation()
  let currentLanguageCode = i18next.resolvedLanguage;

  const [open, setOpen] = useState(false);

  const handleClick : MenuProps['onClick'] = ({ key }: any) => {
    i18n.changeLanguage(key);
    languageCtx.languageCodeHandler();
  };

  const menu = (
    <Menu className={classes.menu}
    onClick={handleClick}
      items={[
        {
          key: 'el',
          label: (
            <>
              ΕΛ
            </>
          ),
        },
        {
          key: 'en',
          label: (
            <>
              EN
            </>
          )
        },
        {
          key: 'fr',
          label: (
            <>
              FR
            </>
          ),
        },
        {
          key: 'de',
          label: (
            <>
              DE
            </>
          ),
        },
      ]}
    />
  )

  return (
    <div className={classes.headerContainer}>
      <Row justify="space-between" id="home" className={classes.home}>
        <LogoContainer to="/" aria-label="homepage" className={classes.logoimg} >
          <img src={logo} className="logo" alt="logo" />
        </LogoContainer>

        <div className={classes.headerMenuContainer}>
          <button>
            <Link to="/">{t("Αρχική")}</Link>
          </button>

          <button>
            <Link to="/museums">{t("Μουσεία")}</Link>
          </button>

          <button>
            <Link to="/collection">{t("Εκθέματα")}</Link>
          </button>

          <button>
            <Link to="/events">{t("Εκδηλώσεις")}</Link>
          </button>

          <button>
            <Link to="/privacy-policy">{t("Σχετικά με το Έργο")}</Link>
          </button>
        </div>

        {/* language selector */}
        <Dropdown className={classes.headerLanguageButtonContainer} overlay={menu} >
          <span className={classes.headerLanguageButton}> 
            {currentLanguageCode === 'el' && 'ΕΛ'} {currentLanguageCode === 'en' && 'ΕΝ'} {currentLanguageCode === 'fr' && 'FR'} {currentLanguageCode === 'de' && 'DE'}
            <CaretUpOutlined style={{width: '.75rem', marginLeft: '-0.15rem', marginTop: '.75rem'}}/>
          </span>
        </Dropdown>

        {/* burger and side menu */}
        <div className={classes.burgerMenuContainer}>
          <Menu1 open={open} setOpen={setOpen} />

          <div
            className={classes.burgerIcon}
            onClick={() => setOpen(true)}
            style={{zIndex: 1, cursor: 'pointer' }}
          >
            <MenuOutlined className='menu-burger' />
          </div>
        </div>
      </Row> 
    </div>
  )
}

export default Header;  